// extracted by mini-css-extract-plugin
export default {"criteriaContainer":"icon-message_criteriaContainer__RUcHL","icon":"icon-message_icon__PQ-DM","criteria":"icon-message_criteria__YLbNx"};